import { CivilCaseConstants } from './../civil-case-constants';
import { SafeJSON } from './../../shared/safe-json';
import { CivilCase } from '../civil-case';
import { CivilCaseUtils } from '../civil-case-utils';


export class Attorney {
    private json: any;
    private key: string;

    constructor(json: any, key: string) {
        this.json = json;
        this.key = key;
    }
    getKey(): string {
        return this.key;
    }
    getAttorneyName(): string {
        return SafeJSON.get('name', this.json);
    }
    getBarNumber(): string {
        let barNumber: string = SafeJSON.getWithDefault('aocAttorneyNumber', this.json);
        if (barNumber.indexOf('AOC') !== -1) {
            return CivilCaseConstants.NO_NC_BARNUMBER;
        }
        barNumber = SafeJSON.get('barNumber', this.json);
        if (barNumber === '') {
            return '-';
        }
        const num = CivilCaseUtils.convertToNumber(barNumber);   // we want to remove the leading zeros
        barNumber = num.toString();
        return barNumber;
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-case-sections/attorney.ts